import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router} from '@angular/router';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ActionGuard implements CanActivate {

  constructor(private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    console.log("ValidateEmailGuard");
    console.log(next);
    console.log(state);
    const action = next.queryParams["action"];
    const code = next.queryParams["code"];
    if(action == "validate-email" && code) {
      console.log("ValidateEmailGuard: true");
      const url = this.router.createUrlTree(["/validate-email"], {queryParams: {code: code}});
      console.log(url);
      this.router.navigateByUrl(url);
      return true;
    }
    return true;
  }

}
